<template>
	<div class="case-cont-parent">
		<div class="case">
			<div class="case-info-sec-top">
				<div class="header5">{{ caseStatus !== "50" ? "Status" : "Case" }}</div>
				<div class="header3">{{ caseStatus !== "50" ? "Case" : "Result" }}</div>
				<div class="paragraph desktop-text">
					Our team will reach out to you as soon as we have an update on your case. If you have any questions, do not hesitate to call us at
					847-790-5028.
					<!-- <span>Please download the
					following documents, make sure to read them carefully before signing.</span> -->
				</div>
			</div>
			<div>
				<CaseInfo :id="id" />
				<!-- <CaseDownload :documents="documents" /> -->
				<CaseStatusBox />
			</div>
		</div>
		<div class="case-back--cont"></div>
	</div>
</template>

<script>
// @ is an alias to /src
import CaseInfo from "@/components/case/CaseInfo.vue";
import CaseDownload from "@/components/case/CaseDownload.vue";
import CaseAttachment from "@/components/case/CaseAttachment.vue";
import CaseStatusBox from "@/components/case/CaseStatusBox.vue";
import Button from "@/components/ui/Button.vue";
import api from "@/store/utils/api";

export default {
	name: "case",
	title: "Case",
	components: {
		CaseInfo,
		CaseDownload,
		CaseAttachment,
		CaseStatusBox,
		Button,
	},
	async mounted() {
		try {
			const documents = await api.get(`/api/v1/orders/${this.$route.params.id}/documents`);
			this.documents = documents;
		} catch (ex) {}
	},
	mounted() {
		this.$store.dispatch("getCase", { id: this.id }).then((res) => {
			console.log("res", res);
			this.caseData = res;
		});
	},
	data() {
		return {
			documents: [],
			date: new Date(),
		};
	},
	computed: {
		id() {
			return this.$route.params.id;
		},
		caseStatus() {
			return this.$store.getters.getCaseData.orderStatus;
		},
	},
};
</script>

<style scoped lang="scss">
.case-cont-parent {
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 1fr;
}
.case-back--cont {
	background: var(--dark-blue);
	display: grid;
	grid-column: 1/-1;
	grid-row: 1/-1;
	position: relative;
	width: 100%;
	height: 500px;
}
.case {
	text-align: left;
	padding: 0 60px;
	padding-top: 120px;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(432px, 1fr));
	grid-gap: 20px;
	grid-row: 1/-1;
	grid-column: 1/-1;
	z-index: 3;

	.desktop-text {
		display: block;
		margin-top: 30px;
		.header4 {
			color: var(--dark-gray);
		}
		.paragraph {
			color: var(--dark-gray);
			opacity: 0.5;
			margin-top: 35px;
		}
	}
	.header5 {
		color: var(--accent);
		padding-bottom: 10px;
	}
	.header3 {
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 36px;
		color: var(--white);
	}
}
@media screen and (max-width: 450px) {
	.case {
		padding: 4rem 1rem;
		grid-template-columns: repeat(auto-fit, minmax(345px, 1fr));
	}
}
</style>
